import { toast } from "react-toastify";
import { FaCopy, FaExpandAlt, FaTimes } from "react-icons/fa";

const CVEs = () => {
  const showExample = (show) => {
    document.getElementById(show).classList.remove("hidden");
  };

  const hideExample = (hide) => {
    document.getElementById(hide).classList.add("hidden");
  };

  const copyExample = () => {
    navigator.clipboard.writeText(
      "import requests\r\nurl = 'https://api.feeds.vederelabs.com/feedservice/api/cves/vlkev'\r\nheaders = {\r\n\t'api-key' : '{your_api_key}'\r\n}\r\nresponse = requests.get(url, headers=headers)\r\nprint(response.text)"
    );
    toast.success("API request has been copied!", {
      position: toast.POSITION.TOP_LEFT,
    });
  };

  return (
    <div className="column">
      <div className="desc-section">
        <h2>Observed Exploited CVEs</h2>
        <p>
          This API query call will enable you to get a list of Vedere Labs known exploited vulnerabilities (VL-KEV).  This call will return a STIX Bundle with a list of Vulnerability objects and related Sighting objects.
        </p>
      </div>
      <div className="example">
        <div className="codeHeader">
          <p>API Request (Python)</p>
          <FaCopy className="icon" onClick={() => copyExample()} />
        </div>
        <div className="code">
          <p className="codeLine">
            <span className="highlight">import</span> requests
          </p>
          <p className="codeLine">
            url <span className="highlight">= "</span>
            <span className="quote">
              https://api.feeds.vederelabs.com/feedservice/api/cves/vlkev?minimum_confidence=high
            </span>
            <span className="highlight">"</span>
          </p>
          <p className="codeLine">
            headers <span className="highlight">= </span> &#123;
          </p>
          <p className="codeLine tab">
            <span className="highlight">'api-key' </span>:
            <span className="highlight"> '&#123;your_api_key&#125;'</span>
          </p>
          <p className="codeLine">&#125;</p>
          <p className="codeLine">
            response <span className="highlight">=</span> requests.get(url,
            headers=headers)
          </p>
          <p className="codeLine">
            <span className="secHighlight">print</span>(response.text)
          </p>
        </div>
      </div>
      <div className="responses">
        <div className="response" onClick={() => showExample("code1")}>
          <div className="greenCircle"></div>
          <p>HTTP code 200 - Successful Response</p>
          <FaExpandAlt className="expand" />
        </div>
        <div className="code hidden" id="code1">
          <FaTimes className="close" onClick={() => hideExample("code1")} />
          <p>&#123;</p>
          <p className="tab">"type": "bundle",</p>
          <p className="tab">"id": "bundle--d3f1c8e2-4f9a-4a2e-9b6e-1a2b3c4d5e6f",</p>
          <p className="tab">"spec_version": "2.1",</p>
          <p className="tab">"objects": [</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "vulnerability",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
          <p className="tab3">"created": "2023-12-01T00:00:00Z",</p>
          <p className="tab3">"modified": "2024-01-15T00:00:00Z",</p>
          <p className="tab3">"name": "CVE-2023-9999",</p>
          <p className="tab3">"confidence": 85,</p>
          <p className="tab3">"description": "Critical remote code execution vulnerability in web application framework. This vulnerability allows unauthenticated attackers to execute arbitrary code on affected systems.",</p>
          <p className="tab3">"labels": [</p>
          <p className="tab4">"is_cisa_kev:false",</p>
          <p className="tab4">"is_vl_kev:true"</p>
          <p className="tab3">],</p>
          <p className="tab3">"external_references": [</p>
          <p className="tab4">&#123;</p>
          <p className="tab5">"source_name": "cve",</p>
          <p className="tab5">"external_id": "CVE-2023-9999",</p>
          <p className="tab5">"url": "https://example.com/?=CVE-2023-9999"</p>
          <p className="tab4">&#125;</p>
          <p className="tab3">],</p>
          <p className="tab3">"x_device_category": ["OT", "IoT"],</p>
          <p className="tab3">"x_cpes": [</p>
          <p className="tab4">"cpe:2.3:a:example_vendor:example_product:1.0:*:*:*:*:*:*:*",</p>
          <p className="tab4">"cpe:2.3:a:example_vendor:example_product:1.1:*:*:*:*:*:*:*"</p>
          <p className="tab3">],</p>
          <p className="tab3">"x_kev_published": [</p>
          <p className="tab4">&#123;</p>
          <p className="tab5">"name": "CISA",</p>
          <p className="tab5">"date": "2023-10-10T00:00:00Z"</p>
          <p className="tab4">&#125;,</p>
          <p className="tab4">&#123;</p>
          <p className="tab5">"name": "VL-KEV",</p>
          <p className="tab5">"date": "2023-11-01T00:00:00Z"</p>
          <p className="tab4">&#125;</p>
          <p className="tab3">],</p>
          <p className="tab3">"x_vulnerability_published": "2023-09-15T00:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "sighting",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "sighting--4333aaaa-4444bbbb-5555cccc-6666dddd7777",</p>
          <p className="tab3">"created": "2024-01-06T00:00:00Z",</p>
          <p className="tab3">"modified": "2024-01-06T00:00:00Z",</p>
          <p className="tab3">"sighting_of_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
          <p className="tab3">"first_seen": "2024-01-02T00:00:00Z",</p>
          <p className="tab3">"last_seen": "2024-01-05T00:00:00Z",</p>
          <p className="tab3">"count": 321,</p>
          <p className="tab3">"where_sighted_refs": [</p>
          <p className="tab4">"observed-data--aaaa1111-bbbb-2222-cccc-3333dddd4444"</p>
          <p className="tab3">],</p>
          <p className="tab3">"x_unique_attacker_ip_counter": 150</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "course-of-action",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "course-of-action--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
          <p className="tab3">"name": "patch",</p>
          <p className="tab3">"created": "2024-05-01T00:00:00Z",</p>
          <p className="tab3">"modified": "2024-05-01T00:00:00Z",</p>
          <p className="tab3">"external_references": [</p>
          <p className="tab4">&#123;</p>
          <p className="tab5">"source_name": "NVD",</p>
          <p className="tab5">"url": "https://example.com/security-patch"</p>
          <p className="tab4">&#125;</p>
          <p className="tab3">],</p>
          <p className="tab3">"x_published" : "2024-05-01T00:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "tool",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "tool--c1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
          <p className="tab3">"name": "CVE-9999 Scanner for Linux",</p>
          <p className="tab3">"created": "2025-10-20T10:00:00Z",</p>
          <p className="tab3">"modified": "2025-10-20T10:00:00Z",</p>
          <p className="tab3">"external_references": [</p>
          <p className="tab4">&#123;</p>
          <p className="tab5">"source_name": "CVE-9999 Scanner for Linux",</p>
          <p className="tab5">"url": "https://github.com/example/cve-9999-scanner"</p>
          <p className="tab4">&#125;</p>
          <p className="tab3">],</p>
          <p className="tab3">"x_created_date": "2025-10-21T09:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "location",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "location--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
          <p className="tab3">"country": "DE",</p>
          <p className="tab3">"created": "2025-10-20T10:00:00Z",</p>
          <p className="tab3">"modified": "2025-10-20T10:00:00Z",</p>
          <p className="tab3">"x_first_seen": "2024-01-01T00:00:00Z",</p>
          <p className="tab3">"x_count": 42</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "infrastructure",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "infrastructure--a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",</p>
          <p className="tab3">"name": "Infrastructure in Germany",</p>
          <p className="tab3">"infrastructure_types": ["unknown"],</p>
          <p className="tab3">"created": "2025-10-31T00:00:00Z",</p>
          <p className="tab3">"modified": "2025-10-31T00:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "relationship",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "relationship--ebcd1234-5678-ijkl-efgh-112233445566",</p>
          <p className="tab3">"relationship_type": "mitigates",</p>
          <p className="tab3">"source_ref": "course-of-action--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
          <p className="tab3">"target_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
          <p className="tab3">"created": "2024-05-01T00:00:00Z",</p>
          <p className="tab3">"modified": "2024-05-01T00:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "relationship",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "relationship--4444aaaa-5555bbbb-6666cccc-7777dddd8888",</p>
          <p className="tab3">"relationship_type": "targets",</p>
          <p className="tab3">"source_ref": "tool--c1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
          <p className="tab3">"target_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
          <p className="tab3">"created": "2024-06-15T00:00:00Z",</p>
          <p className="tab3">"modified": "2024-06-15T00:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "relationship",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "relationship--5555aaaa-6666bbbb-7777cccc-8888dddd9999",</p>
          <p className="tab3">"relationship_type": "located-at",</p>
          <p className="tab3">"source_ref": "infrastructure--a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",</p>
          <p className="tab3">"target_ref": "location--a1b2c3d4-e5f6-7890-abcd-ef1234567890",</p>
          <p className="tab3">"created": "2025-11-01T00:00:00Z",</p>
          <p className="tab3">"modified": "2025-11-01T00:00:00Z"</p>
          <p className="tab2">&#125;,</p>
          <p className="tab2">&#123;</p>
          <p className="tab3">"type": "relationship",</p>
          <p className="tab3">"spec_version": "2.1",</p>
          <p className="tab3">"id": "relationship--6666aaaa-7777bbbb-8888cccc-9999dddd0000",</p>
          <p className="tab3">"relationship_type": "targets",</p>
          <p className="tab3">"source_ref": "infrastructure--a1a1a1a1-b2b2-c3c3-d4d4-e5e5e5e5e5e5",</p>
          <p className="tab3">"target_ref": "vulnerability--11111111-2222-3333-4444-555555555555",</p>
          <p className="tab3">"created": "2025-11-05T00:00:00Z",</p>
          <p className="tab3">"modified": "2025-11-05T00:00:00Z"</p>
          <p className="tab2">&#125;</p>
          <p className="tab">]</p>
          <p>&#125;</p>
        </div>

        <div className="response" onClick={() => showExample("code2")}>
          <div className="redCircle"></div>
          <p>HTTP code 401 - Not authenticated</p>
          <FaExpandAlt className="expand" />
        </div>
        <div className="code hidden" id="code2">
          <FaTimes className="close" onClick={() => hideExample("code2")} />
          <p>&#123;"detail": "Not Authenticated"&#125;</p>
        </div>

        <div className="response" onClick={() => showExample("code3")}>
          <div className="redCircle"></div>
          <p>
            HTTP code 403 - User has not permissions to access the requested
            resource
          </p>
          <FaExpandAlt className="expand" />
        </div>
        <div className="code hidden" id="code3">
          <FaTimes className="close" onClick={() => hideExample("code3")} />
          <p>
            &#123;"detail": "User has not permissions to access the requested
            resource"&#125;
          </p>
        </div>

        <div className="response" onClick={() => showExample("code4")}>
          <div className="redCircle"></div>
          <p>HTTP code 404 - Resource not found</p>
          <FaExpandAlt className="expand" />
        </div>
        <div className="code hidden" id="code4">
          <FaTimes className="close" onClick={() => hideExample("code4")} />
          <p>&#123;"detail": "Resource not found"&#125;</p>
        </div>

        <div className="response" onClick={() => showExample("code5")}>
          <div className="redCircle"></div>
          <p>HTTP code 422 - Validation error</p>
          <FaExpandAlt className="expand" />
        </div>
        <div className="code hidden" id="code5">
          <FaTimes className="close" onClick={() => hideExample("code5")} />
          <p>&#123;"detail": "Validation error"&#125;</p>
        </div>

        <div className="response" onClick={() => showExample("code6")}>
          <div className="redCircle"></div>
          <p>HTTP code 500 - Error processing the request</p>
          <FaExpandAlt className="expand" />
        </div>
        <div className="code hidden" id="code6">
          <FaTimes className="close" onClick={() => hideExample("code6")} />
          <p>&#123;"detail": "Not Found"&#125; </p>
        </div>
      </div>
      <div className="tableOverflow">
        <table className="table">
          <thead>
            <tr className="tableRow">
              <th className="tableHead">Parameter</th>
              <th className="tableHead">Description</th>
              <th className="tableHead">Example</th>
              <th className="tableHead">Default</th>
            </tr>
          </thead>
          <tbody>
            <tr className="tableRow">
              <td className="tableData">start</td>
              <td className="tableData">
                Start of the time period. The format can be either a date in ISO
                format or a relative start (e.g: now-7d)
              </td>
              <td className="tableData">2022-09-31, now-2d, etc. </td>
              <td className="tableData">It returns all CVEs</td>
            </tr>
            <tr className="tableRow">
              <td className="tableData">is_cisa_kev</td>
              <td className="tableData">If it is set to "true" the query returns all the CVEs included in the CISA KEV catalog. If it is set to "false" it only returns the CVEs not included in the CISA KEV catalog. If the filter is missing it returns all the CVEs.</td>
              <td className="tableData">true</td>
              <td className="tableData">It returns all CVEs</td>
            </tr>
            <tr className="tableRow">
              <td className="tableData">minimum_confidence</td>
              <td className="tableData">Returns all the CVEs with a confidence greater or equal to the one selected. Available confidence levels: "low", "medium", or "high"</td>
              <td className="tableData">high</td>
              <td className="tableData">It returns all CVEs</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="field">Response Fields</p>
      <ul className="variables">
        <p className="subfield">STIX Bundle</p>
        <li className="italic">
          <span className="bold">type:</span>type of the STIX Object, it must be
          "bundle" in this case
        </li>
        <li className="italic">
          <span className="bold">id:</span>the ID of the Bundle
        </li>
        <li className="italic">
          <span className="bold">objects:</span>a list of STIX Objects
        </li>
      </ul>
      <ul className="variables">
        <p className="subfield">STIX Vulnerability Object</p>
        <li>
          Each Vulnerability is related to a STIX Sighting Object, <span className="bold">which contains further information such as when the vulnerability was first seen, last seen, and how many times. It also contains the attribute x_unique_attacker_ip_counter that specifies the number of unique IP addresses from which the exploitation attempts are coming.</span>
        </li>
        <li className="italic">
          <span className="bold">type:</span>type of the STIX Object. In this
          case, it must be "vulnerability"
        </li>
        <li className="italic">
          <span className="bold">spec_version:</span>the version of the STIX
          specification used to represent this object. The value of this
          property must be 2.1
        </li>
        <li className="italic">
          <span className="bold">id:</span>the ID of the Vulnerability
        </li>
        <li className="italic">
          <span className="bold">created:</span>the time at which the STIX
          Vulnerability Object was originally created
        </li>
        <li className="italic">
          <span className="bold">modified:</span>the time that this particular
          version of the STIX Object was last modified
        </li>
        <li className="italic">
          <span className="bold">name:</span>the name used to identify the
          Vulnerability
        </li>
        <li className="italic">
          <span className="bold">description:</span>a description that provides
          more details and context about the Vulnerability
        </li>
        <li className="italic">
          <span className="bold">confidence:</span>an integer that represents the level of confidence of the KEV. The higher the confidence the more likely the CVE exploitation could be observed. The confidence levels used are the ones defined in <a href="https://docs.oasis-open.org/cti/stix/v2.1/cs01/stix-v2.1-cs01.html#_1v6elyto0uqg" target="_blank" >STIX 2.1</a>
        </li>
        <li className="italic">
          <span className="bold">x_cpes</span>a list of CPEs associated with this vulnerability
        </li>
        <li className="italic">
          <span className="bold">x_device_category</span>the category of the device or software associated with this vulnerability (e.g. IT, OT)
        </li>
        <li className="italic">
          <span className="bold">x_kev_published</span>a list of dictionaries that contain the name of the organization and the date it was added to that organization's KEV catalogue
        </li>
        <li className="italic">
          <span className="bold">x_vulnerability_published</span>the date the vulnerability was published in the vulnerability database
        </li>
        <li className="italic">
          <span className="bold">labels: </span>labels or tags associated with the CVE (e.g., is_cisa_kev:true)
        </li>
        <li className="italic">
          <span className="bold">external_references: </span> references to the CVE on the nvd.nist.gov platform
        </li>

      </ul>
      <ul className="variables">
        <p className="subfield">STIX Location/Infrastructure Object</p>
        <li className="italic">
          <span className="bold">type:</span>type of the STIX Object. In this
          case, it must be "location" or "infrastructure"
        </li>
        <li className="italic">
          <span className="bold">spec_version:</span>the version of the STIX
          specification used to represent this object. The value of this
          property must be 2.1
        </li>
        <li className="italic">
          <span className="bold">id:</span>the ID of the location/infrastructure object
        </li>
        <li className="italic">
          <span className="bold">name:</span>either the name of the infrastructure or the full name of the country where this vulnerability was detected
        </li>
        <li className="italic">
          <span className="bold">created:</span>the date the location/infrastructure object was created
        </li>
        <li className="italic">
          <span className="bold">modified:</span>the date the location/infrastructure object was modified
        </li>
        <li className="italic">
          <span className="bold">country:</span>(location object only) the country code where this vulnerability was detected
        </li>
        <li className="italic">
          <span className="bold">x_count</span>(location object only) the number of times this vulnerability was detected
        </li>
        <li className="italic">
          <span className="bold">infrastructure_types:</span>(infrastructure object only) a list of the types of infrastructure associated
        </li>
      </ul>
      <ul className="variables">
        <p className="subfield">STIX Course of Action Object</p>
        <li className="italic">
          <span className="bold">type:</span>type of the STIX Object. In this
          case, it must be "course-of-action"
        </li>
        <li className="italic">
          <span className="bold">spec_version:</span>the version of the STIX
          specification used to represent this object. The value of this
          property must be 2.1
        </li>
        <li className="italic">
          <span className="bold">id:</span>the ID of the course of action object
        </li>
        <li className="italic">
          <span className="bold">name:</span>it must be "patch"
        </li>
        <li className="italic">
          <span className="bold">created:</span>the date the course of action object was created
        </li>
        <li className="italic">
          <span className="bold">modified:</span>the date the course of action object was modified
        </li>
        <li className="italic">
          <span className="bold">external_references:</span>a list of dictionaries that includes source_name and url.
        </li>
      </ul>
      <ul className="variables">
        <p className="subfield">STIX Tool Object</p>
        <li className="italic">
          <span className="bold">type:</span>type of the STIX Object. In this
          case, it must be "tool"
        </li>
        <li className="italic">
          <span className="bold">spec_version:</span>the version of the STIX
          specification used to represent this object. The value of this
          property must be 2.1
        </li>
        <li className="italic">
          <span className="bold">id:</span>the ID of the tool object
        </li>
        <li className="italic">
          <span className="bold">name:</span>the name of the tool
        </li>
        <li className="italic">
          <span className="bold">created:</span>the date the tool object was created
        </li>
        <li className="italic">
          <span className="bold">modified:</span>the date the tool object was modified
        </li>
        <li className="italic">
          <span className="bold">external_references:</span>a list of dictionaries that includes source_name and url.
        </li>
      </ul>

    </div>
  );
};

export default CVEs;
